<div class="ui-g-12">

  <div class="ui-g">
    <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
      <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [options]="indicator.options"></app-infobox>
    </div>
  </div>

  <div class="campaigncharts" *ngIf="filterApplied">
    <div class="ui-g">
      <div class="ui-g-12 ui-md-12 ui-sm-12">
        <h2>{{ 'promo.promoUsers' | translate }}</h2>
        <div class="chart-container">
          <chart [options]="promoUsersChart.options" (load)="setChartInstance(promoUsersChart, $event.context)"></chart>
        </div>
      </div>

      <div class="ui-g-12 ui-md-12 ui-sm-12">
        <h2>{{ 'promo.associatedExpensePromo' | translate }}</h2>
        <div class="chart-container">
          <chart [options]="associatedExpensePromoChart.options" (load)="setChartInstance(associatedExpensePromoChart, $event.context)"></chart>
        </div>
      </div>
    </div>
  </div>

  <p-dialog header="Error" [(visible)]="promoError" [width]="300" [modal]="true" [draggable]="false" [resizable]="false">
    <p>{{ 'promo.selectOneErrorMsg' | translate }}</p>
    <div class="ui-dialog-footer">
      <button pButton type="button" class="slim red-button" (click)="toogleErrorPromoDialog()" label="Ok"></button>
    </div>
  </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/customer/performance/promo-performance.component.html